<template>
  <div class="view-search py-5 container">
    <h5 class="mb-4">Buscando por: {{ $route.query.s }}</h5>

    <h6 v-if="results.length" class="mb-4">Cursos</h6>
    <div class="row">
      <div
        v-for="(course, i) in courses"
        :key="i"
        class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"
      >
        <course-card class="flex-fill" :course="course" />
      </div>
    </div>
    <hr />
    <h6 v-if="lessons.length" class="mb-4">Aulas</h6>
    <div v-for="(course, i) in courses" :key="i">
      <h5 v-if="course.lessons.length" class="mb-4">
        Curso: {{ course.title }} {{ course.id }}
      </h5>
      <div class="row">
        <div
          v-for="lesson in course.lessons"
          :key="'l' + lesson.id"
          class="col-lg-4"
        >
          <lesson-preview
            :lesson="lesson"
            :slug="course.slug"
            :courseId="lesson.course"
          />
        </div>
      </div>
      <hr />
    </div>
    <div v-if="showLoading" class="p-3 text-center">
      <b-spinner variant="success" />
    </div>
    <em
      v-else-if="results.length === 0"
      class="text-secondary d-block small mb-5 pb-5"
    >
      Nenhum resultado
    </em>
  </div>
</template>

<script>
import LessonPreview from "../components/course/LessonPreview";
import CourseCard from "@/components/home/CourseCard";
import { mapState } from "vuex";

export default {
  components: { CourseCard, LessonPreview },
  computed: {
    courses() {
      return this.results;
    },
    lessons() {
      return this.results.map(c => c.lessons?.id).flat();
    }
  },
  data() {
    return {
      showLoading: false,
      results: []
    };
  },
  watch: {
    "$route.query.s"(v) {
      this.dispatch(v);
    }
  },
  mounted() {
    this.dispatch(this.$route.query.s.toLowerCase());
  },
  methods: {
    dispatch(query) {
      this.showLoading = true;
      this.$store
        .dispatch("courses/search", query)
        .then(data => {
          this.results = data;
        })
        .finally(() => {
          this.showLoading = false;
        });
    }
  }
};
</script>
